import { templateJoin } from 'bernie-graphql';

export const addPropertyToCartQuery = templateJoin`
        mutation AddPropertyToCart($id: UUID!, $context: ContextInput!, $propertyOffer: PropertyOfferInput!, $cartPropertySearchContextInput: CartPropertySearchContextInput!){
    cartItems(
        id: $id, context: $context
    ) {
        addProperty(key: $propertyOffer, searchContext: $cartPropertySearchContextInput) {
            id
            itemCount
        }
    }
}

    `;

export const createQuestionQuery = templateJoin`
        mutation CreateQuestion($context: ContextInput!, $question: String!, $email: String!, $productId: String!, $questioner: String!, $productQuestionTopic: ProductQuestionTopic!) {
    askProductQuestion(context: $context, question: $question, email: $email, productId: $productId, questioner: $questioner, productQuestionTopic: $productQuestionTopic)
}

    `;

export const createLodgingConversationQuery = templateJoin`
        mutation CreateLodgingConversation($message: String!, $metadata: LodgingConversationMetadataInput!) {
  createLodgingConversation(message:$message, metadata: $metadata) {
    result
    action,
    alert,
    id
  }
}
    `;

export const createMultiItemSessionQuery = templateJoin`
        mutation CreateMultiItemSession($context: ContextInput! $multiItemSearchContext: MultiItemSearchContextInput!) {
  createMultiItemSession(context: $context, searchContext: $multiItemSearchContext) {
    ... on MultiItemSearchContextCreatedResponse {
      shoppingContext {
        multiItem {
          id
          packageType
        }
      }
    }
  }
}

    `;

export const createSessionCartQuery = templateJoin`
        mutation CreateSessionCart($context: ContextInput!, $cartOptions: CartOptionsInput!) {
    createSessionCart(
        context: $context
        cartOptions: $cartOptions
    ) {
        id
    }
}

    `;

export const customerQuery = templateJoin`
        query Customer($context: ContextInput!, $semdtl: String) {
    customer(context: $context, semdtl: $semdtl) {
        currentTripIntent {
            why {
                interests {
                    name
                    desmetId
                }
            }
        }
    }
}

    `;

export const emptyCartQuery = templateJoin`
        mutation EmptyCart($context: ContextInput!, $id: UUID!){
    cartItems(
        id: $id, context: $context
    ) {
        emptyCart {
            id
            itemCount
        }
    }
}
    `;

export const cartQuery = templateJoin`
        query Cart($context: ContextInput!, $id: UUID) {
    cart(
        id: $id, context: $context
    ) {
      itemCount
      items {
        id
        ... on PropertyCartItem {
          offers {
            offerIndex
            naturalKeys {
              id
              roomTypeId
              ratePlanId
              checkIn {
                isoFormat
              }
              checkOut {
                isoFormat
              }
              inventoryType
              rooms {
                 numberOfAdults
                 childAges
              }
            }
            offer {
                marketingChannelId
                units {
                    name
                    photos {
                        description
                        url
                    }
                    ratePlans {
                        priceDetails {
                            availability {
                                available
                                minRoomsLeft
                            }
                            price {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            priceAfterLoyaltyPointsApplied {
                                total {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                                lead {
                                    currency {
                                        code
                                        name
                                        symbol
                                    }
                                    formatted
                                    raw
                                }
                            }
                            fees {
                                description
                            }
                        }
                    }
                }
            }
          }
          summary {
            name
            location {
              address {
                city
              }
            }
          }
          gallery {
            featured {
              url
            }
          }
        }
      }
    }
  }

    `;

export const conversationsQuery = templateJoin`
        query Conversations($propertyId: String!) {
  lodgingConversations(propertyId: $propertyId) {
    newConversation {
      form {
        actionText
        comment {
          label
          placeholder
          invalid
          required
        }
        emailAddress {
          label
          placeholder
          invalid
          required
        }
        name {
          label
          placeholder
          invalid
          required
        }
        resultText
      }
      title
    }
  }
}

    `;

export const findAnswersSearchQuery = templateJoin`
        query FindAnswersSearch($context: ContextInput!, $propertyId: String!, $reviewPagination: PaginationInput!, $reviewSortBy: PropertyReviewSort!, $reviewFilters: PropertyReviewFiltersInput!, $questionFilters: ProductQuestionFiltersInput!, $questionPagination: PaginationInput!, $productQuestionTopic: ProductQuestionTopic!, $questionDateFormat: String!) {
    propertyInfo(propertyId: $propertyId,  context: $context) {
        reviewInfo(sortBy: $reviewSortBy, pagination: $reviewPagination, filters: $reviewFilters) {
            summary {
                superlative
                totalCount {
                    raw
                    formatted
                }
                averageOverallRating {
                    raw
                    formatted
                }
                cleanliness {
                    raw
                    formatted
                }
                serviceAndStaff {
                    raw
                    formatted
                }
                amenityScore {
                    raw
                    formatted
                }
                hotelCondition {
                    raw
                    formatted
                }
                cleanlinessPercent
                serviceAndStaffPercent
                amenityScorePercent
                hotelConditionPercent
                ratingCounts {
                    count {
                        formatted
                        raw
                    }
                    percent
                    rating
                }
                lastIndex
            }
            reviews {
                id
                ratingOverall
                superlative
                submissionTime {
                    raw
                }
                title
                text
                locale
                author
                userLocation
                stayDuration
                helpfulReviewVotes
                negativeRemarks
                positiveRemarks
                locationRemarks
                photos {
                    description
                    url
                }
                managementResponses {
                    id
                    date
                    displayLocale
                    userNickname
                    response
                }
                travelers
                themes {
                    icon {
                        id
                        description
                    }
                    label
                }
            }
        }
    },
    productQuestions(context: $context, productId: $propertyId, filters: $questionFilters, questionPagination: $questionPagination, productQuestionTopic: $productQuestionTopic) {
        totalCount {
            raw
        }
        questions {
            answers {
                answer
                answerTime {
                    formatted(format: $questionDateFormat),
                    raw
                }
                displayName
                id
                upVotes {
                    raw
                }
            }
            createDate {
                formatted(format: $questionDateFormat),
                raw
            }
            id
            question
            questioner
            totalAnswers {
                raw
            }
        }
    }
}

    `;

export const propertyLocationScoreInfoQuery = templateJoin`
        query PropertyLocationScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        propertySummaries {
            propertyId
            locationScore {
                score
                tags {
                    label
                }
            }
        }
    }
}

    `;

export const lodgingPwaPropertySearchQuery = templateJoin`
        query LodgingPwaPropertySearch(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $propertyShopOptions: PropertyShopOptionsInput
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        propertyShopOptions: $propertyShopOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
    ) {
        searchCriteria {
            propertyShopOptions {
                points
            }
            dateRange {
                checkInDate {
                    ...CommonDateFields
                }
                checkOutDate {
                    ...CommonDateFields
                }
            }
            destination {
                regionId
                regionName
            }
            searchIntent {
                theme
                userIntent
                semdtl
            }
            sort
            filters {
                accessibility
                amenities
                bedroomFilter
                commissionTiers
                agencyBusinessModels
                deals
                paymentType
                poi
                priceBuckets
                propertyName
                propertyStyles
                reviewScore {
                    min
                    max
                }
                starList
                structureTypes
                travelerType
                mealPlan
            }
        }
        sortAndFilter {
            defaults {
                sort
                regionId
            }
            selected {
                priceFilterPills {
                    aggregate {
                        label
                        value
                    }
                    buckets
                }
                star
            }
            options {
                appliedFilterCount
                sortAndFilter {
                    selected
                    isRange
                    label
                    max
                    min
                    name
                    placeholder
                    step
                    subLabel
                    hiddenThreshold: seeMoreOptionsToggleThreshold
                    options {
                        selectedLabel
                        ariaLabel
                        description
                        icon
                        isSelected
                        label
                        value
                        optionValue
                        range {
                            min
                            max
                        }
                        filterCategory
                    }
                }
            }
        }
        properties {
            ...CommonPropertyCardFields
            star
            starRatingIcon
            availability {
                available
                text
                theme
            }
            offerSummary {
                messages {
                    message
                    theme
                    type
                }
            }
            legalDisclaimer {
                title
                disclaimerContents
            }
            lodgingPriceBreakDown {
                header
                priceBreakDownEntries {
                    amount
                    description
                    detail
                }
                footer {
                    amount
                    description
                    detail
                }
                unbundledEntries {
                    amount
                    description
                    detail
                }
                ctaLabel
            }
            gallery {
                url
                description
            }
            propertyGallery {
                image {
                    url
                    description
                }
                subjectId
                fallbackImage {
                    url
                    description
                }
            }
            mapMarker {
                icon
                label
                type
                latLong {
                    latitude
                    longitude
                }
            }
            neighborhood {
                name
            }
            offerBadge {
                primary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
                secondary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
            }
            pinnedDetails {
                heading
            }
            recentlyViewed {
                id
                description
            }
            supportingMessages
            shortList {
                favorited
                saveUrl
                removeUrl
                metaData {
                    chkIn
                    chkOut
                    hotelId
                    roomConfiguration
                }
                clickTracking {
                    ... on ShoppingGlobalData {
                        schemaName
                        messageContent {
                            __typename
                            destinationCode
                            destinationName
                            numAdults
                            numChildren
                            shoppingHotel {
                                numRooms
                                rooms {
                                    childrenAges
                                    numAdults
                                    numChildren
                                }
                            }
                            tripEndDate
                            tripStartDate
                        }
                    }
                    ... on AllHotelProductsData {
                        schemaName
                        messageContent {
                            __typename
                            hotelProducts {
                                productId
                                productType
                            }
                        }
                    }
                }
            }
            sponsoredListing {
                id
                clickRedirectTrackingUrl
                clickTrackingUrl
                details
                detailsHeadline
                hotelImage
                impressionTrackingUrl
                trackingData
                brand
                clickRedirectLinkoffTrackingUrl
                logo
                lotagline
                rating
                slots
                vanityUrl
                rank
                position
            }
            highlightedPropertyDetail
            dataAttributes {
                key
                value
            }
            listingFooter {
                actionDetails {
                    name
                }
                icon {
                    description
                    id
                }
                linkUrl
                referrerId
                text
            }
        }
        summary {
            resultsSummary {
                __typename
                value
                ... on LodgingLinkMessage {
                    ...SearchLinkMessage
                }
                ... on LodgingDialogTriggerMessage {
                    ...SearchDialogMessage
                }
            }
            pricedHotelSize
            region {
                name
                id
            }
            resultSectionHeadings {
                heading
                index
            }
            messages {
                title {
                    text
                    icon {
                        description
                        id
                    }
                    theme
                }
                subtitle {
                    text
                    icon {
                        description
                        id
                    }
                    theme
                }
                action {
                    primary {
                        text
                        linkUrl
                        referrerId
                        actionDetails {
                            name
                            details
                        }
                    }
                    secondary {
                        text
                        linkUrl
                        referrerId
                        actionDetails {
                            name
                            details
                        }
                    }
                }
                index
                type
            }
            loyaltyEducation {
                action {
                    href
                    rfrr
                    text
                }
                content {
                    __typename
                    ...PointsEducationFragment
                    ...ProgramEducationFragment
                }
                title
            }
            loyaltyInfo {
                pointsAppliedMessage
                saveWithPointsMessage
                saveWithPointsActionMessage
            }
            matchedPropertiesSize
            resultsHeading
        }
        map {
            bounds {
                northeast {
                    latitude
                    longitude
                }
                southwest {
                    latitude
                    longitude
                }
            }
            center {
                latitude
                longitude
            }
            markers {
                mapMarker {
                    label
                    icon
                    type
                    latLong {
                        latitude
                        longitude
                    }
                }
                __typename
                ... on Property {
                    ...CommonPropertyCardFields
                }
                ... on PointOfInterest {
                    name: title
                }
            }
            staticMapSrc
            title
            subtitle
            zoom
            messagingModel {
                title {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                subtitle {
                    text
                    theme
                    icon {
                        description
                        id
                    }
                }
                type
            }
        }
        exitIntent {
            logoUrl
            backgroundImageUrl
            clickHereLinkUrl
            message {
                headingOne
                headingTwo
                headingThree
                couponCode
                percentOff
                termsAndConditionsOne
                termsAndConditionsTwo
                clickHere
            }
        }
        lodgingIntentMedia {
            city
            countryCode
            machineId
            machineIdHashed
            publisherSessionId
            publisherSessionIdHashed
            publisherUserIdHashed
            referrerChannel
            referrerSource
            state
        }
        shoppingContext {
            multiItem {
                id
            }
        }
        multiItemSearchContext {
            properties {
                primary {
                    rooms {
                        adults
                    }
                    destination {
                        regionId
                        regionName
                    }
                    dateRange {
                        checkInDate {
                            ...CommonDateFields
                        }
                        checkOutDate {
                            ...CommonDateFields
                        }
                    }
                }
            }
            cars {
                primary {
                    pickUpDateTime {
                        ...CommonDateTimeFields
                    }
                    dropOffDateTime {
                        ...CommonDateTimeFields
                    }
                    pickUpLocation {
                        airportCode
                    }
                    dropOffLocation {
                        airportCode
                    }
                }
            }
        }
    }
}

fragment SearchLinkMessage on LodgingLinkMessage {
    link {
        ...SearchLink
    }
    icon {
        id
    }
}

fragment SearchDialogMessage on LodgingDialogTriggerMessage {
    dialogTrigger {
        dialogName
        referrerId
        actionDetails {
            linkUrl
            referrerId
            message
            text
        }

    }
    icon {
        id
    }
}

fragment SearchLink on LodgingLink {
    url
    referrerId
}

fragment CommonPropertyCardFields on Property {
    id
    name
    propertyImage {
        image {
            description
            url
        }
    }
    offerBadge {
        primary {
            text
            theme_temp
            icon_temp {
                id
                description
            }
        }
        secondary {
            text
            theme_temp
            icon_temp {
                id
                description
            }
        }
    }
    price {
        lead {
            formatted
        }
        strikeOutType
        strikeOut {
            formatted
        }
        disclaimer {
            value
        }
        roomNightMessage
        priceMessages {
            value
        }
        marketingFeeDetails {
            tierName
            tierIcon
            marketingFeeMessage {
                value
            }
        }
        options {
            leadingCaption
            displayPrice {
                formatted
            }
            strikeOut {
                formatted
            }
            loyaltyPrice {
                amount {
                    formatted
                }
                unit
            }
            disclaimer {
                value
            }
        }
    }
    reviews {
        score
        localizedScore
        total
        localizedTotal
        superlative
        localizedSubtitle
    }
    destinationInfo {
        distanceFromMessaging
    }
    vipMessaging
    infositeURL
}

fragment CommonDateFields on Date {
    year
    month
    day
}

fragment CommonDateTimeFields on DateTime {
    year
    month
    day
    hour
    minute
    second
}

fragment PointsEducationFragment on LoyaltyPointsEducation {
    description
    programFeatures {
        description
        perks {
            ...PerksFragment
        }
        title
    }
}

fragment ProgramEducationFragment on LoyaltyProgramEducation {
    joinProgramText
    perks {
        ...PerksFragment
    }
}

fragment PerksFragment on LoyaltyEducationPerks {
    descriptions
    icon
}

    `;

export const prepareCheckoutByCartIdQuery = templateJoin`
        mutation PrepareCheckoutByCartId($context: ContextInput!, $id: UUID!, $totalPrice: MoneyInput!, $marketingChannelId: Int) {
    prepareCheckoutByCartId(context: $context, cartId: $id, totalPrice: $totalPrice, marketingChannelId: $marketingChannelId) {
        tripId
        checkoutUrl
        failureReason {
            ... on MaxRoomsFailure {
                groupLinkMessage
                message
            }
        }
    }
}

    `;

export const prepareCheckoutQuery = templateJoin`
        mutation PrepareCheckout($context: ContextInput!, $properties: [PropertyNaturalKeyInput!], $cookies: String!) {
    prepareCheckout(context: $context, properties: $properties, cookies: $cookies) {
        tripId
        checkoutUrl
    }
}

    `;

export const propertyInfoDetailsQuery = templateJoin`
        query PropertyInfoDetails($context: ContextInput!, $propertyId: String!, $requestContext: BffRequestContextInput!) {
    propertyInfo(context: $context, propertyId: $propertyId, bffRequestContext: $requestContext) {
        propertyGallery {
            images {
                alt
                image {
                    description
                    url
                }
                thumbnail {
                    description
                    url
                }
                fallbackImage {
                    description
                    url
                }
                subjectId
            }
            categories {
                id
                name
                images {
                    alt
                    image {
                        description
                        url
                    }
                    thumbnail {
                        description
                        url
                    }
                    fallbackImage {
                        description
                        url
                    }
                    subjectId
                }
            }
        }
        pwaOnlyBffResponse {
            details
        }
        summary {
            name
            nearbyPOIs {
                title
                items {
                    text
                    moreInfo
                    icon {
                        id
                        description
                    }
                }
            }
            location {
                address {
                    addressLine
                    city
                    countryCode
                    firstAddressLine
                    province
                }
                coordinates {
                    latitude
                    longitude
                }
                overviewStaticMapSrc
                whatsAround {
                    title
                    editorial {
                        content
                        crossLink {
                            link {
                                url
                            }
                            value
                        }
                        title
                    }
                    nearbyPOIs {
                        items {
                            text
                            moreInfo
                            icon {
                                id
                                description
                            }
                        }
                        title
                        icon {
                            id
                        }
                    }
                    staticMapSrc
                }
            }
            overview {
                starRating
                vipMessaging
            }
            starRatingIcon {
                description
                id
            }
            telesalesPhoneNumber
            propertyTypeBadge
            amenities {
                amenities {
                    title
                    contents {
                        heading
                        icon {
                            id
                        }
                        items {
                            text
                        }
                    }
                }
                takeover {
                    highlight {
                        heading
                        items {
                            text
                            icon {
                                id
                            }
                        }
                    }
                }
                top {
                    icon {
                        id
                    }
                    text
                }
            }
            map {
                bounds {
                    northeast {
                        latitude
                        longitude
                    }
                    southwest {
                        latitude
                        longitude
                    }
                }
                center {
                    latitude
                    longitude
                }
                markers {
                    ... on PointOfInterest {
                        id
                        title
                        subtitle
                        mapMarker {
                            icon
                            latLong {
                                latitude
                                longitude
                            }
                        }
                    }
                }
                staticMapSrc
                title
                zoom
            }
            navigationBarTabs {
                sectionName
                localizedName
            }
        }
        intentMedia {
            city
            countryCode
            machineId
            machineIdHashed
            publisherSessionId
            publisherSessionIdHashed
            publisherUserIdHashed
            referrerChannel
            referrerSource
            state
        }
        feedback {
            action {
                text
            }
        }
    }
}

    `;

export const propertyInfoOffersBaseQuery = templateJoin`
        query PropertyInfoOffersBase(
    $context: ContextInput!
    $propertyId: String!
    $requestContext: BffRequestContextInput!
) {
    propertyInfo(
        context: $context
        propertyId: $propertyId
        bffRequestContext: $requestContext
    ) {
        pwaOnlyBffResponse {
            offers
        }
    }
}

    `;

export const propertyInfoOffersBexFeaturesQuery = templateJoin`
        query PropertyInfoOffersBexFeatures(
    $context: ContextInput!
    $propertyId: String!
    $requestContext: BffRequestContextInput!
    $dateRange: PropertyDateRangeInput!
    $roomInput: [RoomInput!]!
) {
    propertyInfo(
        context: $context
        propertyId: $propertyId
        bffRequestContext: $requestContext
    ) {
        pwaOnlyBffResponse {
            offers
        }
        offers(
            dateRange: $dateRange
            roomInput: $roomInput
        ) {
            units {
                bookingUrl
                bedOptions {
                    name
                    icon
                }
                description
                id
                name
                header {
                    icon {
                        id
                        description
                    }
                    text
                    subText
                }
                size
                detailsDialog {
                    ...PropertyUnitDetailsDialog
                }
                ratePlansExpando {
                    expandButton {
                        text
                    }
                }
                features {
                    text
                    moreInfo
                    icon {
                        id,
                        description
                    }
                }
                gallery {
                    alt
                    image {
                        description
                        url
                    }
                    thumbnail {
                        description
                        url
                    }
                    fallbackImage {
                        description
                        url
                    }
                    subjectId
                }
            }
            paymentPolicy {
                paymentType
                text
            }
        }
    }
}

fragment PropertyUnitDetailsDialog on PropertyUnitDetailsDialog {
    sleepingArrangement {
        title
        spaces {
            name
            layouts {
                description
                icons {
                    id
                    description
                }
            }
        }
    }
}

    `;

export const propertyRoomScoreInfoQuery = templateJoin`
        query PropertyRoomScoreInfo($propertyIds: [String!]!, $context: ContextInput!) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        propertySummaries {
          propertyId
          roomsScore {
            id
            score
            tags {
              label
            }
          }
        }
    }
}

    `;

export const propertyKeyPhrasesQuery = templateJoin`
        query PropertyKeyPhrases($propertyIds: [String!]!, $context: ContextInput!, $limit: Int, $client: KeyPhrasesClientType) {
    propertyReviewAggregates(
        propertyIds: $propertyIds,
        context: $context
    ) {
        popularMentions(limit: $limit, client: $client)  {
            label
            phrases {
              text
            }
        }
      }
}

    `;

export const propertyPoiContentQuery = templateJoin`
        query PropertyPoiContent(
    $context: ContextInput!
    $poiIDs: String!
) {
    propertyPoiContent(
        context: $context
        poiIDs: $poiIDs
    ) {
        description
        id
        image {
            description
            url
        }
    }
}

    `;

export const propertySearchTravelAdsQuery = templateJoin`
        query PropertySearchTravelAds(
    $context: ContextInput!
    $destination: DestinationInput!
    $rooms: [RoomInput!]
    $dateRange: PropertyDateRangeInput
    $sort: PropertySort
    $filters: PropertySearchFiltersInput
    $marketing: PropertyMarketingInfoInput
    $legacyCriteria: LegacyPropertySearchCriteriaInput
    $propertyShopOptions: PropertyShopOptionsInput
    $searchPagination: PaginationInput
    $searchIntent: SearchIntentInput
    $shoppingContext: ShoppingContextInput
) {
    propertySearch(
        context: $context
        destination: $destination
        rooms: $rooms
        dateRange: $dateRange
        sort: $sort
        filters: $filters
        marketing: $marketing
        legacyCriteria: $legacyCriteria
        propertyShopOptions: $propertyShopOptions
        searchPagination: $searchPagination
        searchIntent: $searchIntent
        shoppingContext: $shoppingContext
    ) {
        properties {
            id
            name
            propertyImage {
                image {
                    description
                    url
                }
            }
            offerBadge {
                primary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
                secondary {
                    text
                    theme_temp
                    icon_temp {
                        id
                        description
                    }
                }
            }
            price {
                lead {
                    formatted
                }
                strikeOutType
                strikeOut {
                    formatted
                }
                disclaimer {
                    value
                }
                roomNightMessage
                priceMessages {
                    value
                }
                marketingFeeDetails {
                    tierName
                    tierIcon
                    marketingFeeMessage {
                        value
                    }
                }
                options {
                    leadingCaption
                    displayPrice {
                        formatted
                    }
                    strikeOut {
                        formatted
                    }
                    loyaltyPrice {
                        amount {
                            formatted
                        }
                        unit
                    }
                    disclaimer {
                        value
                    }
                }
            }
            reviews {
                score
                localizedScore
                total
                localizedTotal
                superlative
                localizedSubtitle
            }
            destinationInfo {
                distanceFromMessaging
            }
            vipMessaging
            infositeURL
            star
            starRatingIcon
            availability {
                available
                text
                theme
            }
            offerSummary {
                messages {
                    message
                    theme
                    type
                }
            }
            legalDisclaimer {
                title
                disclaimerContents
            }
            neighborhood {
                name
            }
            recentlyViewed {
                id
                description
            }
            supportingMessages
            shortList {
                favorited
                saveUrl
                removeUrl
                metaData {
                    chkIn
                    chkOut
                    hotelId
                    roomConfiguration
                }
                clickTracking {
                    ... on ShoppingGlobalData {
                        schemaName
                        messageContent {
                            __typename
                            destinationCode
                            destinationName
                            numAdults
                            numChildren
                            shoppingHotel {
                                numRooms
                                rooms {
                                    childrenAges
                                    numAdults
                                    numChildren
                                }
                            }
                            tripEndDate
                            tripStartDate
                        }
                    }
                    ...on AllHotelProductsData {
                        schemaName
                        messageContent {
                            __typename
                            hotelProducts {
                                productId
                                productType
                            }
                        }
                    }
                }
            }
            sponsoredListing {
                id
                clickRedirectTrackingUrl
                clickTrackingUrl
                details
                detailsHeadline
                hotelImage
                impressionTrackingUrl
                trackingData
                brand
                clickRedirectLinkoffTrackingUrl
                logo
                lotagline
                rating
                slots
                vanityUrl
                rank
                position
            }
            highlightedPropertyDetail
            dataAttributes {
                key
                value
            }
        }
    }
}

    `;

export const removeItemFromCartQuery = templateJoin`
        mutation RemoveItemFromCart($cartId: UUID!, $context: ContextInput!, $itemId: UUID!){
    cartItems(
        id: $cartId, context: $context
    ) {
        remove(id: $itemId) {
            id
            itemCount
        }
    }
}

    `;

export const translateReviewQuery = templateJoin`
        query TranslateReview($context: ContextInput!, $hotelId: String!, $reviewId: String!, $targetLocale: Locale) {
  propertyInfo(context: $context, propertyId: $hotelId) {
    review(id: $reviewId, locale: $targetLocale) {
    ...HotelReview
    }
  }
}


fragment HotelReview on PropertyReview {
    id
    locale
    photos {
        description
        url
    }
    ratingOverall
    submissionTime {
        raw
    }
    text
    title
    userLocation
    userNickname
}

    `;

export const reviewsQuery = templateJoin`
        query Reviews($context: ContextInput!, $propertyId: String!, $pagination: PaginationInput!, $sortBy: PropertyReviewSort!, $filters: PropertyReviewFiltersInput!) {
    propertyInfo(propertyId: $propertyId,  context: $context) {
        reviewInfo(sortBy: $sortBy, pagination: $pagination, filters: $filters) {
            summary {
                superlative
                totalCount {
                    raw
                    formatted
                }
                reviewCountLocalized
                averageOverallRating {
                    raw
                    formatted
                }
                cleanliness {
                    raw
                    formatted
                }
                serviceAndStaff {
                    raw
                    formatted
                }
                amenityScore {
                    raw
                    formatted
                }
                hotelCondition {
                    raw
                    formatted
                }
                cleanlinessPercent
                cleanlinessOverMax
                serviceAndStaffPercent
                serviceAndStaffOverMax
                amenityScorePercent
                amenityScoreOverMax
                hotelConditionPercent
                hotelConditionOverMax
                ratingCounts {
                    count {
                        formatted
                        raw
                    }
                    percent
                    rating
                }
                lastIndex
                reviewDisclaimer
            }
            reviews {
                id
                ratingOverall
                superlative
                submissionTime {
                    raw
                }
                title
                text
                locale
                author
                userLocation
                stayDuration
                helpfulReviewVotes
                negativeRemarks
                positiveRemarks
                locationRemarks
                photos {
                    description
                    url
                }
                managementResponses {
                    id
                    date
                    displayLocale
                    userNickname
                    response
                }
                travelers
                themes {
                    icon {
                        id
                        description
                    }
                    label
                }
            }
            sortAndFilter {
                sortAndFilter {
                    name
                    label
                    options {
                        label
                        isSelected
                        optionValue
                    }
                }
            }
        }
    }
}

    `;

export const questionAnswersQuery = templateJoin`
        query QuestionAnswers($context: ContextInput!, $productId: String!, $filters: ProductQuestionFiltersInput!, $pagination: PaginationInput!, $productQuestionTopic: ProductQuestionTopic!, $questionDateFormat: String!) {
    productQuestions(context: $context, productId: $productId, filters: $filters, questionPagination: $pagination, productQuestionTopic: $productQuestionTopic) {
        totalCount {
            raw
        }
        questions {
            answers {
                answer
                answerTime {
                formatted(format: $questionDateFormat),
                raw
                }
                displayName
                id
                upVotes {
                    raw
                }
            }
            createDate {
                formatted(format: $questionDateFormat),
                raw
            }
            id
            question
            questioner
            totalAnswers {
                raw
            }
        }
    }
}

    `;

export const upvotePropertyReviewQuery = templateJoin`
        mutation UpvotePropertyReview($reviewId: String!) {
  upvotePropertyReview(id: $reviewId)
}
    `;
